




















import Vue from 'vue'
import style from './style.module.scss'
import Inputmask from 'inputmask';

export default Vue.extend({
    name: 'text-input',
    props: {
        value: String,
        placeholder: String,
        error: Boolean,
        disabled: Boolean,
        autocomplete: String,
        maxlength: String,
        settings: {},
    },
    data() {
        return {
            style: style
        }
    },
    computed: {
        model: {
            get(): string {
                return this.value
            },
            set(value: string): void {
                this.$emit('input', value);
            }
        }
    },
    directives: {
        'local-mask': {
            bind: function(el, binding) {
                Inputmask(binding.value).mask(el);
            }
        }
    }
})
